'use client'
import Script from 'next/script'
//import blukai, removido
import { GoogleTagManager } from '@next/third-parties/google'

export function Scripts() {
  return <>
    {/*Script blukai, removido*/}
    <Script id="analytics">
      {`
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '${process.env.NEXT_PUBLIC_PIXEL}');
        fbq('track', 'PageView');
      `}
    </Script>
    <Script id="qualtrics">
      {`
        window.pais_web = "NI";
        
        // Variables de control para Qualtrics
        window.qualtricsScriptLoaded = false;
        window.qualtricsInitialized = false;
        window.qualtricsCurrentlyActive = false;
        
        // Función para inicializar Qualtrics (cargar script por primera vez)
        window.initializeQualtrics = function() {
          if (window.qualtricsScriptLoaded) {
            return Promise.resolve();
          }
          
          return new Promise(function(resolve, reject) {
            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = 'https://znuz1bkdy2fu9f4cr-clarocentroamerica.siteintercept.qualtrics.com/SIE/?Q_ZID=ZN_UZ1bkdY2fu9f4CR';
            
            script.onload = function() {
              window.qualtricsScriptLoaded = true;
              
              // Esperar a que QSI esté disponible
              var waitForQSI = setInterval(function() {
                if (window.QSI && window.QSI.API) {
                  clearInterval(waitForQSI);
                  window.qualtricsInitialized = true;
                  resolve();
                }
              }, 100);
              
              // Timeout de seguridad
              setTimeout(function() {
                clearInterval(waitForQSI);
                if (!window.qualtricsInitialized) {
                  reject(new Error('Timeout esperando QSI API'));
                }
              }, 5000);
            };
            
            script.onerror = function() {
              reject(new Error('Error cargando script de Qualtrics'));
            };
            
            document.body.appendChild(script);
          });
        };
        
        // Función para mostrar Qualtrics Site Intercept
        window.loadQualtricsSiteIntercept = function() {
          
          // Si ya está activo, no hacer nada
          if (window.qualtricsCurrentlyActive) {
            return;
          }
          
          // Inicializar si no está hecho
          window.initializeQualtrics().then(function() {
            if (window.QSI && window.QSI.API) {
              try {
                
                // Siempre hacer unload primero para limpiar cualquier estado previo
                window.QSI.API.unload();
                
                // Esperar un momento y luego load + run
                setTimeout(function() {
                  window.QSI.API.load();
                  
                  setTimeout(function() {
                    window.QSI.API.run();
                    window.qualtricsCurrentlyActive = true;
                    
                    // Configurar listener para detectar cierre
                    window.setupCloseDetection();
                  }, 200);
                }, 100);
                
              } catch(e) {
                console.error('Error ejecutando Qualtrics:', e);
              }
            } else {
              console.error('QSI API no está disponible');
            }
          }).catch(function(error) {
            console.error('Error inicializando Qualtrics:', error);
          });
        };
        
        // Función para detectar cuando se cierra Qualtrics
        window.setupCloseDetection = function() {
          var checkClosed = setInterval(function() {
            if (window.qualtricsCurrentlyActive) {
              // Buscar elementos activos de Qualtrics con diferentes selectores
              var activeElements = document.querySelectorAll(
                '[id*="QSI_"], [class*="QSI_"], [data-qa*="close"], .QSI_Container, #QSI_TargetZone'
              );
              
              var hasVisibleElements = false;
              for (var i = 0; i < activeElements.length; i++) {
                var el = activeElements[i];
                var style = window.getComputedStyle(el);
                if (style.display !== 'none' && style.visibility !== 'hidden' && el.offsetHeight > 0) {
                  hasVisibleElements = true;
                  break;
                }
              }
              
              if (!hasVisibleElements) {
                window.qualtricsCurrentlyActive = false;
                clearInterval(checkClosed);
              }
            } else {
              clearInterval(checkClosed);
            }
          }, 500);
          
          // Timeout de seguridad para resetear después de 60 segundos
          setTimeout(function() {
            if (window.qualtricsCurrentlyActive) {
              window.qualtricsCurrentlyActive = false;
              clearInterval(checkClosed);
            }
          }, 60000);
        };
        
        // Función manual para cerrar Qualtrics (para debugging)
        window.closeQualtrics = function() {
          if (window.QSI && window.QSI.API) {
            window.QSI.API.unload();
            window.qualtricsCurrentlyActive = false;
          }
        };
        
        // Función para resetear completamente Qualtrics (solo para debug)
        window.resetQualtrics = function() {
          // Limpiar elementos del DOM
          var overlays = document.querySelectorAll('[id*="QSI_"], [class*="QSI_"]');
          overlays.forEach(function(overlay) {
            if (overlay.parentNode) {
              overlay.parentNode.removeChild(overlay);
            }
          });
          
          // Remover scripts
          var existingScripts = document.querySelectorAll('script[src*="qualtrics.com"]');
          existingScripts.forEach(function(script) {
            if (script.parentNode) {
              script.parentNode.removeChild(script);
            }
          });
          
          // Resetear variables
          window.qualtricsScriptLoaded = false;
          window.qualtricsInitialized = false;
          window.qualtricsCurrentlyActive = false;
          window.QSI = undefined;
          
        };
      `}
    </Script>
    <GoogleTagManager gtmId={process.env.NEXT_PUBLIC_TAG} />
    <GoogleTagManager gtmId={process.env.NEXT_PUBLIC_TAG2} />
  </>
}
